/* tslint:disable */
/* eslint-disable */
/**
 * Authentication-API
 * This API allows strong authentication with LuxTrust.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostUserRequest
 */
export interface PostUserRequest {
    /**
     * technical id of esklepios user
     * @type {string}
     * @memberof PostUserRequest
     */
    esklepiosId?: string;
    /**
     * luxtrust matricule
     * @type {string}
     * @memberof PostUserRequest
     */
    ssn?: string;
    /**
     * user roles
     * @type {string}
     * @memberof PostUserRequest
     */
    roles?: string;
}

/**
 * Check if a given object implements the PostUserRequest interface.
 */
export function instanceOfPostUserRequest(value: object): value is PostUserRequest {
    return true;
}

export function PostUserRequestFromJSON(json: any): PostUserRequest {
    return PostUserRequestFromJSONTyped(json, false);
}

export function PostUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'esklepiosId': json['esklepiosId'] == null ? undefined : json['esklepiosId'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'roles': json['roles'] == null ? undefined : json['roles'],
    };
}

export function PostUserRequestToJSON(json: any): PostUserRequest {
    return PostUserRequestToJSONTyped(json, false);
}

export function PostUserRequestToJSONTyped(value?: PostUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'esklepiosId': value['esklepiosId'],
        'ssn': value['ssn'],
        'roles': value['roles'],
    };
}

